export default "__VITE_ASSET__CwLyjCgo__"